import { MenuIcon } from './MenuIcon';

export type { TypeMenuIconProps } from './types';
export default MenuIcon;
